(() => {
  const classify = (title, tags = '') => {
    const text = (title + ' ' + tags).toLowerCase();
    const sports = [['Basketball',/basketball|wnba|nba/],['Baseball',/baseball|mlb/],['Football',/football|nfl/],['Soccer',/soccer|k league|premier league/],['Hockey',/hockey|nhl/],['Tennis',/tennis/],['Golf',/golf/],['Racing',/racing|formula 1|nascar|track kings/],['UFC / MMA',/ufc|mma/],['Wrestling',/wrestling|wwe|aew/],['Non-Sport',/marvel|disney|star wars|non.sport|entertainment/]];
    return {sport: sports.find(([,re])=>re.test(text))?.[0] || 'Other', brand: /topps|bowman/.test(text) ? (/bowman/.test(text) ? 'Bowman' : 'Topps') : /panini/.test(text) ? 'Panini' : /upper deck|skybox|metal universe/.test(text) ? 'Upper Deck / SkyBox' : 'Other', year: title.match(/20\d{2}(?:[–—-]\d{2})?/)?.[0].replace(/[–—]/g,'-') || 'Other'};
  };
  const directory = document.querySelector('[data-guide-directory]');
  if (directory && !directory.dataset.ready) {
    directory.dataset.ready = 'true';
    const start = async () => {
      const grid = directory.querySelector('.mosa-directory__grid');
      let next = directory.querySelector('.mosa-directory__next');
      let partial = false;
      const visited = new Set();
      while (next && !visited.has(next.href)) {
        visited.add(next.href);
        try {
          const response = await fetch(next.href);
          if (!response.ok) throw new Error('directory');
          const page = new DOMParser().parseFromString(await response.text(),'text/html');
          const incoming = page.querySelector('[data-guide-directory]');
          if (!incoming) throw new Error('directory');
          grid.append(...incoming.querySelectorAll('.mosa-directory__card'));
          const following = incoming.querySelector('.mosa-directory__next');
          next.remove();
          next = following;
          if (next) directory.append(next);
        } catch { partial = true; break; }
      }
      const cards = [...grid.querySelectorAll('.mosa-directory__card')];
      cards.forEach(card => Object.assign(card.dataset,classify(card.dataset.guideTitle,card.dataset.guideTags)));
      const search = directory.querySelector('[data-guide-search]');
      const filters = [...directory.querySelectorAll('[data-guide-filter]')];
      filters.forEach(select => {
        const key = select.dataset.guideFilter;
        const values = [...new Set(cards.map(c=>c.dataset[key]))].sort((a,b)=>key==='year'?b.localeCompare(a):a.localeCompare(b));
        values.forEach(value=>{const option=document.createElement('option'); option.value=value; option.textContent=value; select.append(option);});
      });
      const render = () => {
        const query = search.value.trim().toLowerCase();
        let count = 0;
        cards.forEach(card => {
          const match = (card.dataset.guideTitle+' '+card.dataset.guideTags).toLowerCase().includes(query) && filters.every(s=>!s.value || card.dataset[s.dataset.guideFilter]===s.value);
          card.hidden = !match;
          if (match) count++;
        });
        directory.querySelector('[data-guide-count]').textContent = directory.dataset.countTemplate.replace('[count]', count).replace('[total]',cards.length) + (partial ? ' ' + directory.dataset.partialLabel : '');
        directory.querySelector('[data-guide-empty]').hidden = count > 0;
      };
      search.addEventListener('input',render);
      filters.forEach(s=>s.addEventListener('change',render));
      directory.querySelector('[data-guide-reset]').addEventListener('click',()=>{search.value='';filters.forEach(s=>s.value='');render();search.focus();});
      directory.querySelector('.mosa-directory__filters').hidden = false;
      render();
    };
    start();
  }
  const related = document.querySelector('[data-related-guides]');
  if (related && !related.dataset.ready) {
    related.dataset.ready = 'true';
    const current = JSON.parse(related.querySelector('[data-current-guide]').textContent);
    const catalog = JSON.parse(related.querySelector('[data-related-catalog]').textContent);
    const currentType = classify(current.title,current.tags.join(' '));
    const words = current.title.toLowerCase().split(/[^a-z0-9]+/).filter(w=>w.length>3 && !['checklist','parallels','product','guide','odds'].includes(w));
    const ranked = catalog.filter(g=>g.url!==current.url).map((guide,index)=>{
      const type = classify(guide.title,guide.tags.join(' '));
      const score = (currentType.sport!=='Other' && type.sport===currentType.sport?20:0)+(type.brand===currentType.brand && type.brand!=='Other'?4:0)+words.filter(w=>guide.title.toLowerCase().includes(w)).length;
      return {guide,score,index};
    }).sort((a,b)=>b.score-a.score || a.index-b.index).slice(0,3);
    ranked.forEach(({guide})=>{
      const card=document.createElement('article');card.className='mosa-directory__card';
      const link=document.createElement('a');link.href=guide.url;
      if(guide.image){const img=document.createElement('img');img.src=guide.image;img.alt='';img.loading='lazy';img.width=400;img.height=300;link.append(img);}
      const heading=document.createElement('h3');heading.textContent=guide.title;link.append(heading);card.append(link);related.querySelector('.mosa-directory__grid').append(card);
    });
    if(ranked.length){document.querySelector('.mosa-guide')?.append(related);related.hidden=false;}
  }
})();
